import { useState } from 'react';
import { Lock, Loader2, CheckCircle2 } from 'lucide-react';
import AdminLayout from '../../components/AdminLayout';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Card, CardContent, CardHeader, CardTitle, CardDescription,
} from '../../components/ui/card';
import api from '../../lib/api';
import { toast } from 'sonner';

const AdminChangePassword = () => {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next !== confirm) {
      toast.error('As senhas novas não conferem');
      return;
    }
    if (next.length < 6) {
      toast.error('Senha deve ter no mínimo 6 caracteres');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/change-password', { current_password: current, new_password: next });
      toast.success('Senha alterada com sucesso!');
      setCurrent('');
      setNext('');
      setConfirm('');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Erro ao alterar senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title="Alterar Minha Senha">
      <div className="max-w-xl">
        <Card className="rounded-2xl">
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-indigo-100">
                <Lock className="w-5 h-5 text-indigo-600" />
              </div>
              <div>
                <CardTitle className="font-heading">Alterar senha</CardTitle>
                <CardDescription>Use uma senha forte. Mínimo 6 caracteres.</CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="current">Senha atual</Label>
                <Input
                  id="current"
                  type="password"
                  value={current}
                  onChange={(e) => setCurrent(e.target.value)}
                  required
                  data-testid="cp-current"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="next">Nova senha</Label>
                <Input
                  id="next"
                  type="password"
                  value={next}
                  onChange={(e) => setNext(e.target.value)}
                  required
                  minLength={6}
                  data-testid="cp-new"
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="confirm">Confirme a nova senha</Label>
                <Input
                  id="confirm"
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  required
                  minLength={6}
                  data-testid="cp-confirm"
                />
              </div>
              <Button type="submit" disabled={loading} data-testid="cp-submit">
                {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <CheckCircle2 className="w-4 h-4 mr-2" />}
                Salvar nova senha
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </AdminLayout>
  );
};

export default AdminChangePassword;
